<template>
  <div id="header-guide" class="container column is-paddingless-top is-paddingless-bottom">
    <div class="header columns">
      <div class="column columns is-3 is-paddingless">
        <div class="column">
          <router-link to="/" class="logoLink">
            <transition name="fade" mode="in-out" appear>
              <img :key="logoSrc" :src="getLogoSrc">
            </transition>
          </router-link>
        </div>
      </div>
      <div class="columns is-mobile column is-padding-left-small is-paddingless-top is-paddingless-bottom">
        <div class="tabs">
          <ul>
            <li class="is-active">
              <router-link to="/">
                Guide d'utilisation
              </router-link>
            </li>
            <li v-if="profil != null">
              <a href="#">Tutoriel vidéo</a>
            </li>
            <li v-if="profil != null">
              <a href="#">Support technique</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'MyHeader',
    logoSrc: '',

    props: {
      logoSrc: {
        required: true,
        type: String
      }
    },

    data () {
      return {

      }
    },

    computed: {
      ...mapState(['profil']),
      getLogoSrc () {
        console.log('******** this.logoSrc : '+this.logoSrc)
        return this.logoSrc
      }
    }

  }
</script>




<style lang="css" scoped>

  .logoLink{ height: 40px; display:block; }
  .logoLink img{ height:inherit; width:auto; }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .5s, transform .5s;
      transform: translateX(0px);
  }
  .fade-enter{
      opacity: 0;
      transform: translateX(-20px);
  }
  .fade-leave-to{
      opacity: 0;
      transform: translateX(40px);
  }

</style>
